import type { HelpFile } from '../../types/help'
import { AccountDetailTestIds } from '../../../testids/AccountDetailTestIds'

export const accountDetailHelp: HelpFile = {
  docPage: '/docs/identity/accounts',
  texts: {
    [AccountDetailTestIds.accountDetailPage]:
      'Full record for a single account — who owns it, which target system it lives in, its current lifecycle state, and the audit timestamps.',
    [AccountDetailTestIds.cardAccountDetails]:
      'Core account fields drawn from the target system and the linked identity.',
    [AccountDetailTestIds.linkAccountIdentity]:
      'The identity this account is provisioned for. Follow the link to the identity profile.',
    [AccountDetailTestIds.linkAccountSystem]:
      'The target system that owns this account. Follow the link to the system overview.',
    [AccountDetailTestIds.accountExternalIdentifier]:
      'The identifier the target system uses for this account — for example, the LDAP DN, the database username, or the SCIM user ID. Use this when reconciling against the system of record.',
    [AccountDetailTestIds.accountStatusBadge]:
      'Current lifecycle state of the account in the target system: enabled, disabled, or locked.',
    [AccountDetailTestIds.sectionAccountAttributes]:
      'Dynamic attributes attached to this account — extend the schema without code changes.',
  },
}
